import * as React from 'react';

import { Link } from '@coursera/cds-core';

import PageFooter from 'bundles/page-footer/components/PageFooter';
import PageHeader from 'bundles/page-header/components/PageHeader';
import { CourseraMetatags } from 'bundles/seo';

import _t from 'i18n!nls/account-settings';

import 'css!./__styles__/DeletionConfirmation';

const SUPPORT_LINK = 'https://learner.coursera.help/hc/requests/new?ticket_form_id=120983';

class DeletionConfirmation extends React.Component {
  render() {
    return (
      <div className="rc-DeletionConfirmation">
        <CourseraMetatags metaNameAndProperties={{ title: 'Delete Account Confirmation' }} />

        <div className="c-account-settings">
          <PageHeader hideRightNav />
          <main className="c-account-settings-body">
            <div className="delete-confirmation-message" aria-live="assertive" role="alert">
              <h2 className="headline-3-text">{_t('Goodbye!')}</h2>
              <p>
                {_t(
                  `You have successfully deleted your Coursera account.
                    You should receive a confirmation email shortly.`
                )}
              </p>
              <p>
                {_t(`If you'd like help with your deleted account, please `)}
                <Link href={SUPPORT_LINK} variant="standard">
                  {_t('contact us')}
                </Link>
              </p>
            </div>
          </main>
          <PageFooter />
        </div>
      </div>
    );
  }
}

export default DeletionConfirmation;
